import ReduxRedirect from './ReduxRedirect'
export default ReduxRedirect